import React, { useEffect, useRef, useState } from "react";
import {
  Grid,
  TextField,
  Button,
  IconButton,
  InputAdornment,
  FormControl,
  InputLabel,
  OutlinedInput,
  Alert,
  Typography,
  CircularProgress
} from "@mui/material";

import { Navigate, useNavigate } from "react-router-dom";

import axiosClient from "../axiosClient";
import axiosClientSevan from "../axiosClientSevan";

import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useStateContext } from "../context/ContextProvider";

const InsertFirstDetailsScreen = () => {
  const [goToProducts, setGoToProducts] = useState();
  const [customerEmail, setCustomerEmail] = useState();
  const [customerId, setCustomerId] = useState();
  const [customerBillId, setCustomerBillId] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const [showRePassword, setShowRePassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [companyId, setCompanyId] = useState();
  const [companyBillId, setCompanyBillId] = useState();
  const [verified, setVerified] = useState();
  const [resellerCode, setResellerCode] = useState(null);
  const [loading,setLoading] = useState(false);

  const [passwordVisibility, setPasswordVisibility] = useState(true);
  const [companyVisibility, setCompanyVisibility] = useState(false);
  const [storeVisibility, setStoreVisibility] = useState(false);

  const [dataArray, setDataArray] = useState([]);

  const { setStore } = useStateContext();

  const passwordRef = useRef();
  const companyNameRef = useRef();
  const companyShortNameRef = useRef();
  const companyAddressRef = useRef();
  const companyZipRef = useRef();
  const companyBillingEmailRef = useRef();
  const companyVatNumberRef = useRef();
  const companyTelephoneRef = useRef();
  const storeNameRef = useRef();
  const storeAddressRef = useRef();
  const storeZipRef = useRef();
  const storeTelephoneRef = useRef();
  const repasswordRef = useRef();
  const customerNameRef = useRef();

  const navigate = useNavigate();

  const [preview, setPreview] = useState();
  const [change, onChange] = useState();

  const handleChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
        onChange(file);
      };
      reader.readAsDataURL(file);
    }
  };

  const isStrongPassword = (password) => {
    // Regular expressions to check for at least one digit, one capital letter, and one symbol
    const digitRegex = /\d/;
    const capitalRegex = /[A-Z]/;
    const symbolRegex = /[$&+,:;=?@#|'<>.^*()%!-]/;

    // Check if the password meets all criteria
    return (
      digitRegex.test(password) &&
      capitalRegex.test(password) &&
      symbolRegex.test(password)
    );
  };

  const handleSaveCompany = () => {
    const companyPayload = {
      params: {
        companyName: companyNameRef.current.value,
        companyShortName: companyShortNameRef.current.value,
        address: companyAddressRef.current.value,
        zip: companyZipRef.current.value,
        billingEmail: companyBillingEmailRef.current.value,
        vatNumber: companyVatNumberRef.current.value,
        telephone: companyTelephoneRef.current.value,
        companyBillId: 0,
        customerId: customerId,
      },
    };

    axiosClient
      .post("customer/company/create", companyPayload)
      .then((response) => {
        const companyId = response.data.companyId
        setCompanyId(companyId)
        setCompanyVisibility(false);
        setStoreVisibility(true);
        setErrorMessage("");
        
        const payloadSevan = {
          customer_code: customerBillId,
          company_name: companyNameRef.current.value,
          platform_name: "SOFTECH"
        };

        axiosClientSevan
          .post("api/create/company", payloadSevan)
          .then((response) => {
            const companyBillId = parseInt(response.data.data.company_code)
            setCompanyBillId(companyBillId)
            const payload_bill = {
              params: {
                id: companyId,
                comp_bill_id: parseInt(companyBillId),
              },
            };
  
            axiosClient
              .patch("customer/company/bill", payload_bill)
              .catch((err) => console.log(err));
          });
      })
      .catch((err) => {
        const errorMessage = err.response.data.message.errors.map((e) => {
          return (
            <>
              {e.message}
              <br></br>
            </>
          );
        });
        setErrorMessage(errorMessage);
      });
  };

  const handleSavePassword = () => {
    if (!isStrongPassword(passwordRef.current.value)) {
      setErrorMessage(
        "Password must contain one symbol one number and one capital letter at least"
      );
    } else if (passwordRef.current.value !== repasswordRef.current.value) {
      setErrorMessage("Password and re-password must be the same!");
    } else {
      const customerPayload = {
        params: {
          email: customerEmail,
          password: passwordRef.current.value,
        },
      };

      axiosClient
        .patch("customer/password", customerPayload)
        .then((response) => {
          setDataArray((prevArray) => [...prevArray, "password"]);
          setPasswordVisibility(false);
          setCompanyVisibility(true);
          setErrorMessage("");
        })
        .catch((err) => console.log(err));

      const payloadSevan = {
        customer_code: customerBillId,
        password: passwordRef.current.value,
        platform_name: "SOFTECH",
      };

      axiosClientSevan
        .put("api/update/customer", payloadSevan)
        .then((response) => {
          setPasswordVisibility(false);
          setCompanyVisibility(true);
          setErrorMessage("");
        })
        .catch((err) => {
          setPasswordVisibility(false);
          setCompanyVisibility(true);
          setErrorMessage("");
        });
    }
  };

  const handleSaveStore = () => {
    var base64Data;
    var binaryData;

    if (preview === null || preview === undefined) {
      base64Data = null;
      binaryData = null;
    } else {
      base64Data = preview?.split(",")[1]; // Extract the Base64 data
      binaryData = atob(base64Data);
    }

    const storePayload = {
      params: {
        storeName: storeNameRef.current.value,
        address: storeAddressRef.current.value,
        zip: storeZipRef.current.value,
        license_date_expiration: new Date(), // this is the free trial how many days of free trial they have, currenlty they dont have
        activeLicense: true,
        telephone: storeTelephoneRef.current.value,
        logo: binaryData,
        storeBillId: 0,
        CompanyId: companyId,
        resellerCode: resellerCode,
      },
    };

    axiosClient
      .post("customer/company/store/create", storePayload)
      .then((response) => {
        setErrorMessage("");
        setStoreVisibility(false);
        setLoading(true)
        
        const storeId = response.data.storeId

        let storeDetails = JSON.parse(response.data.store);

        const payloadSevan = {
          company_code: companyBillId,
          shop_name: storeNameRef.current.value,
          service_id: 301,
          platform_name: "SOFTECH"
        };

        axiosClientSevan.post("api/create/shop", payloadSevan).then((response) => {

          storeDetails.store_bill_id = response.data.data.shop_code;
          setStore(JSON.stringify(storeDetails));

            const payload_bill = {
              params: {
                id: storeId,
                store_bill_id: parseInt(response.data.data.shop_code),
              },
            };
  
            axiosClient
              .patch("customer/store/bill", payload_bill)
              .then(()=> {
                setGoToProducts(true)
                setLoading(false)
              })
              .catch((err) => {
                console.log(err)
                setLoading(false)
              })
        });
    
      })
      .catch((err) => {
        console.log(err)
        setLoading(false)
        const errorMessage = err.response.data.err.errors.map((e) => {
          return (
            <>
              {e.message}
              <br></br>
            </>
          );
        });
        setErrorMessage(errorMessage);
      });

  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleToggleRePasswordVisibility = () => {
    setShowRePassword(!showRePassword);
  };

  useEffect(() => {
    axiosClient
      .get("customer/authenticated")
      .then((response) => {
        setCustomerBillId(response.data.cust_bill_id);
        setVerified(response.data.verified);
        if (response.data.customer.length === 0) {
          setGoToProducts(false);
          setCustomerEmail(response.data.customer_email);
          setCustomerId(response.data.customer_id);
          setCompanyVisibility(true);
        } else if (
          response.data.customer.length !== 0 &&
          response.data.customer[0].Stores.length === 0
        ) {
          setGoToProducts(false);
          setPasswordVisibility(false);
          setCompanyVisibility(false);
          setStoreVisibility(true);
          setCompanyId(response.data.customer[0].id);
          setCompanyBillId(response.data.customer[0].company_bill_id);
        } else {
          setGoToProducts(true);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  if (goToProducts) {
    return <Navigate to="/products" />;
  }

  if (loading) {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CircularProgress />
        </Grid>
      </Grid>
    );
  }

  return (
    <div>
      {errorMessage && (
        <Grid item xs={12} sm={6}>
          <Alert severity="error" sx={{ marginBottom: 2 }}>
            {errorMessage}
          </Alert>
        </Grid>
      )}
      <Grid container spacing={2}>
        {passwordVisibility && !verified && (
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Typography variant="h6" gutterBottom>
              Customer Profile
            </Typography>
          </Grid>
        )}
        {passwordVisibility && !verified && (
          <Grid item md={6} lg={6} sm={6} xs={12}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Customer Email"
              fullWidth
              disabled
              value={customerEmail}
            />
          </Grid>
        )}
        {passwordVisibility && !verified && (
          <Grid item md={6} lg={6} sm={6} xs={12}>
            <TextField
              label="Customer Name"
              fullWidth
              inputRef={customerNameRef}
            />
          </Grid>
        )}
        {passwordVisibility && !verified && (
          <Grid item md={6} lg={6} sm={6} xs={12}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel htmlFor={`outlined-adornment-password`}>
                Password
              </InputLabel>
              <OutlinedInput
                id={`outlined-adornment-password`}
                type={showPassword ? "text" : "password"}
                inputRef={passwordRef}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleTogglePasswordVisibility}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
                label="Password"
              />
            </FormControl>
          </Grid>
        )}
        {passwordVisibility && !verified && (
          <Grid item md={6} lg={6} sm={6} xs={12}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel htmlFor={`outlined-adornment-password`}>
                Re-Password
              </InputLabel>
              <OutlinedInput
                id={`outlined-adornment-password`}
                type={showRePassword ? "text" : "password"}
                inputRef={repasswordRef}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleToggleRePasswordVisibility}
                      edge="end"
                    >
                      {showRePassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
                label="Password"
              />
            </FormControl>
          </Grid>
        )}
        {passwordVisibility && !verified && (
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 16,
              }}
            >
              <Button
                variant="contained"
                color="success"
                style={{ marginRight: 16, marginLeft: 16 }}
                onClick={handleSavePassword}
              >
                Save customer profile
              </Button>
            </Grid>
          </Grid>
        )}
        {companyVisibility && (
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Typography variant="h6" gutterBottom>
              Company details
            </Typography>
          </Grid>
        )}
        {companyVisibility && (
          <Grid item md={3} lg={3} sm={3} xs={12}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Company name"
              fullWidth
              inputRef={companyNameRef}
            />
          </Grid>
        )}
        {companyVisibility && (
          <Grid item md={3} lg={3} sm={3} xs={12}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Company short name"
              fullWidth
              inputRef={companyShortNameRef}
            />
          </Grid>
        )}
        {companyVisibility && (
          <Grid item md={3} lg={3} sm={3} xs={12}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Company address"
              fullWidth
              inputRef={companyAddressRef}
            />
          </Grid>
        )}{" "}
        {companyVisibility && (
          <Grid item md={3} lg={3} sm={3} xs={12}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Company zip"
              fullWidth
              inputRef={companyZipRef}
            />
          </Grid>
        )}{" "}
        {companyVisibility && (
          <Grid item md={3} lg={3} sm={3} xs={12}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Company billing email"
              fullWidth
              inputRef={companyBillingEmailRef}
            />
          </Grid>
        )}{" "}
        {companyVisibility && (
          <Grid item md={3} lg={3} sm={3} xs={12}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Company VAT number"
              fullWidth
              inputRef={companyVatNumberRef}
            />
          </Grid>
        )}{" "}
        {companyVisibility && (
          <Grid item md={3} lg={3} sm={3} xs={12}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Company telephone"
              fullWidth
              inputRef={companyTelephoneRef}
            />
          </Grid>
        )}{" "}
        {companyVisibility && (
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 16,
              }}
            >
              <Button
                variant="contained"
                color="success"
                style={{ marginRight: 16, marginLeft: 16 }}
                onClick={handleSaveCompany}
              >
                Save company details
              </Button>
            </Grid>
          </Grid>
        )}
        {storeVisibility && (
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Typography variant="h6" gutterBottom>
              Store details
            </Typography>
          </Grid>
        )}{" "}
        {storeVisibility && (
          <Grid item md={3} lg={3} sm={3} xs={12}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Store name"
              fullWidth
              inputRef={storeNameRef}
            />
          </Grid>
        )}{" "}
        {storeVisibility && (
          <Grid item md={3} lg={3} sm={3} xs={12}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Store address"
              fullWidth
              inputRef={storeAddressRef}
            />
          </Grid>
        )}{" "}
        {storeVisibility && (
          <Grid item md={3} lg={3} sm={3} xs={12}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Store zip"
              fullWidth
              inputRef={storeZipRef}
            />
          </Grid>
        )}{" "}
        {storeVisibility && (
          <Grid item md={3} lg={3} sm={3} xs={12}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Store telephone"
              fullWidth
              inputRef={storeTelephoneRef}
            />
          </Grid>
        )}{" "}
        {storeVisibility && (
          <Grid item md={3} lg={3} sm={3} xs={12}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Reseller code"
              fullWidth
              value={resellerCode}
              onChange={(e) => {
                setResellerCode(e.target.value)
              }}
            />
          </Grid>
        )}{" "}
        {storeVisibility && (
          <Grid item md={3} lg={3} sm={3} xs={12}>
            <div className="image-input-container">
              <input
                type="file"
                accept="image/jpeg"
                onChange={handleChange}
                className="input-file"
              />
              {preview && (
                <img src={preview} alt="Preview" className="preview-image" />
              )}
              {!preview && (
                <div className="placeholder">Click to select an image</div>
              )}
            </div>
          </Grid>
        )}{" "}
        {storeVisibility && (
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 16,
              }}
            >
              <Button
                variant="contained"
                color="success"
                style={{ marginRight: 16, marginLeft: 16 }}
                onClick={handleSaveStore}
              >
                Save store details
              </Button>
            </Grid>
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default InsertFirstDetailsScreen;
